import { Action, createReducer, on } from '@ngrx/store';
import { Organization } from '../../../api/models/organization';
import { readAllOrganizationsSuccess } from '../actions/organization.actions';

export interface OrganizationState {
  organizations: Organization[] | undefined;
}

export const initialState: OrganizationState = {
  organizations: undefined,
};

const organizationsReducer = createReducer(
  initialState,
  on(readAllOrganizationsSuccess, (state, result) => setOrganizations(state, result))
);

export const setOrganizations = (state: OrganizationState, result: { organizations: Organization[] }) => {
  return {
    ...state,
    organizations: result.organizations,
  };
};

export const getOrganizations = (state: OrganizationState) => state.organizations;

export function reducer(state: OrganizationState | undefined, action: Action): any {
  return organizationsReducer(state, action);
}
